import {Inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {PICMONIC_CONFIG, PicmonicConfig} from 'libs/shared/environment/src/lib/tokens/picmonic-config.token';
import {ServiceResponse} from 'libs/shared/model/src/lib/models/service-response.model';
import {ServiceManagerHttpService} from 'libs/shared/http/src/lib/services/http/http.service';
import {IdentityService, UserRole} from 'libs/shared/http/src/lib/services/identity/identity.service';
import {PicmonicAccountMergeRequest} from '../model/picmonic-account-merge.model';
import {PicmonicPayload} from '../model/picmonic-payload.model';
import {
    ValidatePicmonicAccountMergeRequest,
    ValidatePicmonicAccountMergeResponse
} from '../model/validate-picmonic-account-merge.model';
import {GetPicmonicNavigationLinks} from '../model/picmonic-navigation-links.model';
import {IsPicmonicExamBankResponse} from '../model/picmonic-exambank.model';

@Injectable({
    providedIn: 'root'
})
export class PicmonicService {
    constructor(
        private httpService: ServiceManagerHttpService,
        private identityService: IdentityService,
        @Inject(PICMONIC_CONFIG) private picmonicConfig: PicmonicConfig
    ) {}

    getPicmonicLtiPayload(
        examBankId: number,
        context: {PicmonicId: number; QuestionUniqueName: string}
    ): Observable<ServiceResponse & PicmonicPayload> {
        const url = '/picmonic/payload';

        const body = {
            ExamBankId: examBankId,
            Picmonic: context
        };

        return this.httpService.post(url, body);
    }

    hasPicmonicAccess(): Observable<boolean> {
        return this.identityService.isInRole(UserRole.Picmonic);
    }

    isPicmonicExamBank(examBankId: number): Observable<IsPicmonicExamBankResponse> {
        const url = `/subscription/IsPicmonicExamBank/${examBankId}`;
        return this.httpService.get(url);
    }

    canMergePicmonicAccount(
        request: ValidatePicmonicAccountMergeRequest
    ): Observable<ValidatePicmonicAccountMergeResponse> {
        const url = '/account/merge/account/picmonic/validation';

        return this.httpService.post(url, request);
    }

    mergePicmonicAccount(request: PicmonicAccountMergeRequest): Observable<ServiceResponse> {
        const url = '/account/merge/account/picmonic';

        return this.httpService.post(url, request);
    }

    getPicmonicNavigationLinks(): Observable<GetPicmonicNavigationLinks> {
        const url = '/account/PicmonicNavigationLinks';

        return this.httpService.get(url);
    }

    getPerformanceReportLink(): string {
        const query = new URLSearchParams();
        query.append('redirect', 'performance');
        return `${this.picmonicConfig.EntrypointUrl}?${query.toString()}`;
    }

    navigateToDailyQuiz(): void {
        const query = new URLSearchParams();
        query.append('redirect', 'quiz/daily');
        window.open(`${this.picmonicConfig.EntrypointUrl}?${query.toString()}`, '_self');
    }

    navigateToContinueDailyQuiz(): void {
        const query = new URLSearchParams();
        query.append('redirect', 'quiz/daily/continue');
        window.open(`${this.picmonicConfig.EntrypointUrl}?${query.toString()}`, '_self');
    }

    navigateToExplorePage(): void {
        const query = new URLSearchParams();
        query.append('redirect', 'explore');
        window.open(`${this.picmonicConfig.EntrypointUrl}?${query.toString()}`, '_self');
    }

    navigateToStudentDashboard(): void {
        const query = new URLSearchParams();
        query.append('redirect', '/home?dashboard=student');
        window.open(`${this.picmonicConfig.EntrypointUrl}?${query.toString()}`, '_self');
    }
}
